import { makeStyles } from "@material-ui/core"

// Styles for the Page Container
const usePCStyles = makeStyles((theme) => ({
	container: {
		paddingTop: theme.spacing(3),
		paddingBottom: theme.spacing(15),
	},
}))

export default usePCStyles
